<template>
  <section>

    <div class="search-container">
    <!--
    <select id="languageSwitcher" v-model="selectedLanguage" @change="switchLanguage">
      <option value="ja">日本語</option>
      <option value="en">English</option>
    </select>
    <h2 id="search-title">離島検索</h2>
    -->
      <!-- 変更箇所: v-modelを削除し、@inputイベントを使用する -->
      <input type="text" id="search" :value="searchQuery" @input="onSearchQueryChange" placeholder="島名または住所で検索">
      <table v-if="routeConfigs.length > 0" id="islandTable">
        <thead>
          <tr>
            <th @click="sortTable('name')">島名</th>
            <th @click="sortTable('prefecture')">住所</th>
            <!--
          <th @click="sortTable('population')">人口</th>
          <th @click="sortTable('area')">面積 (km²)</th>
          -->
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in paginatedData" :key="item.path">
            <td><a :href="base + item.path"><ruby>{{ item.name }}<rt>{{ item.kana }}</rt></ruby></a></td>
            <td>{{ item.prefecture + item.address }}</td>
            <!--
          <td>{{ item.population }}</td>
          <td>{{ item.area }}</td>
          -->
          </tr>
        </tbody>
      </table>

      <div class="pagination">
        <button v-for="page in pageCount" :key="page" @click="setCurrentPage(page)" :disabled="currentPage === page">
          <!--
          <button v-for="page in pageCount" :key="page" @click="currentPage = page" :disabled="currentPage === page">
          -->
          {{ page }}
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
export default {
  data() {
    return {
      base: '', // 初期値を設定
      // items: [] // ダミーデータを入れる場所。適宜変更してください
    };
  },
  computed: {
    // 'island' モジュールから状態をマッピング
    ...mapState('island', ['routeConfigs', 'selectedLanguage', 'filteredRoutes', 'searchQuery', 'currentPage', 'pageSize']),
    ...mapGetters('island', ['paginatedData', 'pageCount']),
    pageCount() {
      return Math.ceil(this.filteredRoutes.length / this.pageSize);
    }
  },
  methods: {
    ...mapActions('island', ['fetchRoutes', 'changeLanguage', 'filterData', 'sortData', 'setCurrentPage', 'updateSearchQuery']),
    ...mapMutations('island', ['setCurrentPage']),
    // searchQueryが変更されたときのイベントハンドラー
    onSearchQueryChange(event) {
      console.log("Search query changed:", event.target.value);  // Check input value
      this.updateSearchQuery(event.target.value);
    }
  },
  created() {
    // console.log("SearchView created()");
    this.fetchRoutes();  // ルートデータの取得
    this.filterData();   // 初期データのフィルタリング
    // Vue Routerのbaseパスを取得
    this.base = this.$router.options.history.base || '';
  }
};
</script>

<style scoped>
h2#search-title {
  margin: 10px;
  text-align: center;
  color: #333;
}

.search-container {
  width: 100%;
  max-width: 700px;
  background-color: white;
  margin: 20px auto;
  padding: 20px;
  /*
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  */
  position: relative;
}

#search {
  width: 100%;
  box-sizing: border-box;
  padding: 10px;
  margin-bottom: 20px;
  border: 1px solid #ccc;
  border-radius: 4px;
  /*
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  */
}

table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
}

table,
th,
td {
  border: 1px solid #ddd;
}

th {
  padding: 6px;
  font-weight: 100;
}
td {
  padding: 12px;
  text-align: left;
}

th {
  background-color: #f2f2f2;
  cursor: pointer;
}

th:hover {
  background-color: #e0e0e0;
}

tr:nth-child(even) {
  background-color: #f9f9f9;
}

tr:hover {
  background-color: #f1f1f1;
}

.pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.pagination button {
  background-color: rgb(10, 110, 230);;
  color: white;
  border: none;
  padding: 10px 15px;
  margin: 0 2px;
  border-radius: 4px;
  cursor: pointer;
}

.pagination button:hover {
  background-color: rgb(8, 100, 210);
}

.pagination button:disabled {
  background-color: #ccc;
  cursor: default;
}

@media (max-width: 600px) {
  .container {
    padding: 10px;
  }

  th,
  td {
    padding: 8px;
  }

  #search {
    padding: 8px;
  }

  .pagination button {
    padding: 8px 10px;
    margin: 0 1px;
  }
}
</style>